import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const UpdateControlSlide = async (payload: any, eventId: any, email: string) => {
  try {
    const response = await axios.put(`${HOSTAPI}/events/setSlideControl/${eventId}/presenter/${email}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response
  } catch (error: any) {
    return {
      status: error.response.status,
      data: error.response.data,
    };
  }
};

export default UpdateControlSlide;
